import React, { useEffect, useState } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import {
  addeditdata
} from "../../../controllers/relationshipManagers/relManagersController";
import { fetchIpAddress } from "../../../controllers/API";

const UserListEditPage = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const listQuery = state?.listQuery;
  const managerData =
    state?.item !== undefined
      ? state.item
      : state && !state.listQuery
      ? state
      : {};
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(managerData);
  const [passwordVisible, setPasswordVisible] = useState(false);
  // const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({
    // vendor_account_number: ADDEDITDATA?.vendor_account_number || "",
  });
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };
  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const {
        _id,
        name,
        email,
        phone,
        cc_accounts
      } = ADDEDITDATA;
      const ipAddress = await fetchIpAddress();

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("edit_id", _id);
      }
      form.append("name", name?name:'');
      form.append("email", email?email:'');
      form.append("phone", phone?phone:'');

      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);

      if (isValidate) {
        const options = {
          url: "accounts/relationship-managers/addeditdata",
          postData: form,
        };
        const res = await addeditdata(options);
        if (res.status === true) {
          notification.open({
            message: "Data updated!",
            description: `Data updated successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/relationship-managers/list", { state: { listQuery } });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Oops!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  /*********************************************************
   *  This function is used to validate form data before submit
   *********************************************************/
  const validateFormData = (formData) => {
    // const companyname = /^[A-Za-z0-9\s]+$/;
    const name = /^[A-Za-z\s]+$/; 
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.get("name")?.trim() || formData.get("name") === '' || formData.get("name") === 'undefined' ) {
      setError((prevError) => ({
        ...prevError,
        name: "Company name is required",
      }));
      return false;
    }
    if(!name.test(formData.get("name"))){
      setError((prevError) => ({
        ...prevError,
        name: "Please enter a valid name",
      }));
      return false;
    }
    if (!formData.get("email")?.trim() || formData.get("email") === '' || formData.get("email") === 'undefined') {
      setError((prevError) => ({
        ...prevError,
        email: "Email id is required",
      }));
      return false;
    }
    if (!emailPattern.test(formData.get("email"))) {
      setError((prevError) => ({
        ...prevError,
        email: "Please enter a valid email id",
      }));
      return false;
    }
    return true;
  };

  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} Relationship Managers
            </h5>
          </div>
          <Link to="/relationship-managers/list" state={{ listQuery }}>
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row inventory_form_main_content_form_section">
                  <div className="row">
                    <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="name"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Name :{" "}
                      </label>
                      <input
                        title="Name"
                        placeholder="Enter name"
                        type="text"
                        name="name"
                        className="form-control store_input_field"
                        id="name"
                        value={ADDEDITDATA?.name}
                        onChange={handleChange}
                      />
                      {error.name ? (
                        <p style={{ color: "red" }}>
                          {error.name}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="email"
                        className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Email Address :
                      </label>
                      <input
                        title="Enter email address."
                        placeholder="Enter email address."
                        type="text"
                        name="email"
                        className="form-control store_input_field"
                        id="email"
                        value={ADDEDITDATA?.email}
                        onChange={handleChange}
                      />
                      {error.email ? (
                        <p style={{ color: "red" }}>{error.email}</p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="phone"
                        className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Phone :
                      </label>
                      <input
                        title="Enter phone no."
                        placeholder="Enter phone no."
                        type="text"
                        name="phone"
                        className="form-control store_input_field"
                        id="phone"
                        value={ADDEDITDATA?.phone}
                        onChange={handleChange}
                      />
                      {error.phone ? (
                        <p style={{ color: "red" }}>{error.phone}</p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {/* <hr /> */}
                </div>
                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <LoadingEffect isLoading={isLoading} /> */}
    </div>
  );
};

export default UserListEditPage;
